// import React from 'react';
// import styles from './InputComponents.module.css';

// const SingleCheckboxInput = ({ question, value, error, onChange, isSubmitted }) => {
//     // Handle checkbox value (can be boolean or object with checked + text)
//     const checkboxValue = typeof value === 'object' ? value?.checked : value;
//     const isChecked = checkboxValue === true || checkboxValue === 'true' || checkboxValue === 'YES';

//     // Handle additional input value (details about the condition)
//     const additionalValue = typeof value === 'object' ? value?.details || '' : '';

//     const handleCheckboxChange = (checked) => {
//         // Always store as object to support additional details
//         onChange({
//             checked: checked,
//             details: checked ? additionalValue : '' // Clear details when unchecked
//         });
//     };

//     const handleDetailsChange = (inputValue) => {
//         // Allow only numbers (and decimal point if needed)
//         const numbersOnly = inputValue.replace(/[^0-9.]/g, '');

//         onChange({
//             checked: isChecked,
//             details: numbersOnly
//         });
//     };

//     return (
//         <div className={styles.singleCheckboxContainer}>
//             <label
//                 className={`${styles.checkboxLabel} ${isChecked ? styles.checkboxLabelChecked : ''}`}
//                 htmlFor={question.id}
//             >
//                 <input
//                     type="checkbox"
//                     id={question.id}
//                     checked={isChecked}
//                     onChange={(e) => handleCheckboxChange(e.target.checked)}
//                     disabled={isSubmitted}
//                     className={styles.checkboxInput}
//                 />
//                 <span className={styles.checkboxBox}>
//                     {isChecked && (
//                         <svg className={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
//                             <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                         </svg>
//                     )}
//                 </span>
//                 <span className={styles.optionText}>{question.label}</span>
//             </label>

//             {/* Show details input when checkbox is checked */}
//             {isChecked && (
//                 <div className={styles.detailsInputWrapper}>
//                     <label className={styles.detailsLabel}>
//                         Duration (in years):
//                     </label>
//                     <input
//                         type="text"
//                         inputMode="numeric"
//                         value={additionalValue}
//                         onChange={(e) => handleDetailsChange(e.target.value)}
//                         placeholder="e.g., 5 or 2.5"
//                         disabled={isSubmitted}
//                         className={styles.detailsInput}
//                     />
//                     <small className={styles.helpText}>
//                         Enter duration in years (numbers only)
//                     </small>
//                 </div>
//             )}

//             {error && <span className={styles.errorText}>{error}</span>}
//         </div>
//     );
// };

// export default SingleCheckboxInput;

import React from 'react';
import styles from './SingleCheckboxInput.module.css';
import { Check, AlertCircle } from 'lucide-react';

const SingleCheckboxInput = ({ 
    question,
    value, 
    onChange, 
    error,
    isSubmitted,
    linkedField,
    linkedFieldValue,
    linkedFieldError,
    onLinkedFieldChange,
    disabled = false,
    onBlur
}) => {
    const isChecked = value === true || value === 'true' || value === 'YES';
    const hasLinkedField = linkedField && isChecked;
    const label = question?.label || question?.text || '';
    const isFormDisabled = disabled;

    const handleCheckboxChange = () => {
        if (isFormDisabled) return;
        onChange(!isChecked);
        // Note: Reason modal is now handled by handleImmediateFieldChange in DynamicForm
        // Clear linked field value when unchecking
        if (isChecked && linkedField && onLinkedFieldChange) {
            onLinkedFieldChange('');
        }
    };

    const handleLinkedFieldChange = (e) => {
        if (isFormDisabled) return;
        let inputValue = e.target.value;
        
        // Apply validation pattern if exists
        if (linkedField?.validation?.pattern === 'numeric') {
            inputValue = inputValue.replace(/[^0-9]/g, '');
        }
        
        // Prevent entering 0 as the first/only digit when min is 1 or greater
        if (linkedField?.validation?.min >= 1 && inputValue === '0') {
            return; // Don't allow just "0"
        }
        
        // Remove leading zeros (except for empty string)
        if (inputValue.length > 1 && inputValue.startsWith('0')) {
            inputValue = inputValue.replace(/^0+/, '');
        }
        
        // Apply maxLength
        if (linkedField?.validation?.maxLength) {
            inputValue = inputValue.slice(0, linkedField.validation.maxLength);
        }
        
        if (onLinkedFieldChange) {
            onLinkedFieldChange(inputValue);
        }
    };

    return (
        <div className={styles.checkboxWithLinkedField}>
            <div className={styles.checkboxRowContainer}>
                {/* Checkbox */}
                <label 
                    className={`${styles.singleCheckboxOption} ${isChecked ? styles.singleCheckboxOptionSelected : ''} ${isFormDisabled ? styles.disabled : ''}`}
                >
                    <input
                        type="checkbox"
                        className={styles.checkboxInput}
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        disabled={isFormDisabled}
                    />
                    <span className={`${styles.checkboxBox} ${isChecked ? styles.checkboxBoxSelected : ''}`}>
                        {isChecked && <Check className={styles.checkIcon} />}
                    </span>
                    <span className={styles.checkboxLabelText}>{label}</span>
                </label>

                {/* Linked Field - shows only when checkbox is checked */}
                {hasLinkedField && (
                    <div className={styles.linkedFieldWrapper}>
                        <label className={styles.linkedFieldLabel}>
                            {linkedField.label}
                        </label>
                        <input
                            type="text"
                            className={`${styles.linkedFieldInput} ${linkedFieldError ? styles.inputError : ''} ${linkedField.type === 'text' ? styles.linkedFieldInputText : ''}`}
                            value={linkedFieldValue || ''}
                            onChange={handleLinkedFieldChange}
                            placeholder=""
                            maxLength={linkedField.validation?.maxLength || (linkedField.type === 'text' ? 200 : 2)}
                            disabled={isFormDisabled}
                        />
                    </div>
                )}
            </div>

            {/* Error messages */}
            {error && (
                <div className={styles.errorMessage}>
                    <AlertCircle className={styles.errorIcon} />
                    <span>{error}</span>
                </div>
            )}
            {linkedFieldError && (
                <div className={styles.errorMessage}>
                    <AlertCircle className={styles.errorIcon} />
                    <span>{linkedFieldError}</span>
                </div>
            )}
        </div>
    );
};

export default SingleCheckboxInput;